export const KEY_NAME = {
  workCount: "workCount",
  publiclyAccessibleYes: "publiclyAccessibleYes",
  publiclyAccessibleUnknown: "publiclyAccessibleUnknown",
  licenseYes: "licenseYes",
  licenseUnknown: "licenseUnknown",
  archiveYes: "archiveYes",
  archiveUnknown: "archiveUnknown",
  onFunderPortal: "onFunderPortal",
  okOrcid: "okOrcid",
  unknownOrcid: "unknownOrcid",
  okDatasetCount: "okDatasetCount",
  unknownDatasetCount: "unknownDatasetCount",
  FUNDER: "funders",
  PUBLISHER: "publishers",
  INSTITUTION: "institutions",
};
